import { render, staticRenderFns } from "./input-tag.vue?vue&type=template&id=6776efcf&scoped=true"
import script from "./input-tag.vue?vue&type=script&lang=js"
export * from "./input-tag.vue?vue&type=script&lang=js"
import style0 from "./input-tag.vue?vue&type=style&index=0&id=6776efcf&prod&scoped=true&lang=scss"
import style1 from "./input-tag.vue?vue&type=style&index=1&id=6776efcf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6776efcf",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
